export const en = {
    error: 'Something went wrong, please try again later'
};
